import React, { Component } from 'react'
import { mdiPlusBoxOutline       , } from '@mdi/js';
import Icon from '@mdi/react';
import IntlMessages from 'util/IntlMessages';

export default class Avbryta extends Component {
    render() {
        return (
            <div className="d-flex table-status-label"style={{
              borderRadius: 5,
              width:90,
              //border:"2px solid rgb(255, 159, 67)",
              backgroundColor: '#FFF0E1',  }}>
                <div style={{
                  width: 25,
                  height: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft:3,
                  marginRight: 3,
                }} >
                  <Icon 
                    path={mdiPlusBoxOutline   }
                    size={1}
                    color="rgb(255, 159, 67)"/>
                </div>
                <div style={{marginTop: '8px', marginRight: 10,}}>
                    <h5 style={{margin:'0', color: 'rgb(255, 159, 67)',  fontWeight: 400, whiteSpace: 'nowrap',fontSize:14}}><IntlMessages id="Created"/></h5>
                </div>
            </div>
           
        )
    }
}
